import { Dimensions } from 'editor/src/store/design/types';

function getNewImageDisplaySize(area: Dimensions, imageWidth: number, imageHeight: number, ratio = 0.8) {
  let width = 0;
  let height = 0;

  if (area.width / area.height < imageWidth / imageHeight) {
    // Canvas is taller than image → scale by width
    width = Math.round(area.width * ratio);
    height = (width * imageHeight) / imageWidth;
  } else {
    // Canvas is wider than image → scale by height
    height = Math.round(area.height * ratio);
    width = (height * imageWidth) / imageHeight;
  }

  return { width, height };
}

export default getNewImageDisplaySize;
